import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { fetchApp, selectAppEditable } from '../../../../entities/Application'
import {
	mapRightsNoPermissionToNull
} from '../../../../shared/lib/mappers/mapRightsNoPermissionToNull'

export const updateApp = createAsyncThunk<
	void,
	void,
	ThunkConfig<string>
>('updateApplication', async (_, thunkAPI) => {

	const { dispatch, extra: { api }, getState, rejectWithValue } = thunkAPI
	const editedApp = selectAppEditable(getState())
	const rights = mapRightsNoPermissionToNull(editedApp.rights)
	const editedAppDTO = { ...editedApp, rights }

	try {
		await api.put(`/applications/${editedApp.applicationId}`, editedAppDTO)

		showToast({
			type: 'success',
			toastId: 'updateApplication',
			message: 'Success'
		})

		dispatch(fetchApp(editedApp.applicationId))
	} catch (e) {
		console.log(e)
		appHandleError(e, 'updateApplication', 'Application update failed')
		return rejectWithValue('Error occurred on application update')
	}
})
